import React from 'react';
import './Footer.css';

const Footer = () => {
  // eslint-disable-next-line no-unused-vars
  const handleGoToApp = () => {
    // Redirigir a la aplicación principal
    window.location.href = 'http://localhost:3000';
  };

  // eslint-disable-next-line no-unused-vars
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      {/* Footer Top Section */}
              <div className="footer-top">
          <div className="footer-left-section">
            <div className="footer-logo-container">
              <img src="/images/logofooter.png" alt="DataFono Crypto" />
            </div>
            <div className="footer-slogan-container">
              <div className="footer-slogan">
                Con tu celular, cobrá en<br />cripto sin fronteras.
              </div>
            </div>
          </div>
          <nav className="footer-nav">
            <ul className="footer-nav-list">
              <li>
                <a href="#app" onClick={e => {
                  e.preventDefault();
                  window.location.href = window.location.hostname === 'localhost'
                    ? 'http://localhost:3000/'
                    : '/app/';
                }}>
                  Inicio
                </a>
              </li>
              <li>
                <a href="#how-it-works" onClick={e => {
                  e.preventDefault();
                  const section = document.getElementById('how-it-works');
                  if (section) {
                    section.scrollIntoView({ behavior: 'smooth' });
                  }
                }}>
                  ¿Cómo funciona?
                </a>
              </li>
              <li>
                <a href="#faqs" onClick={e => {
                  e.preventDefault();
                  const section = document.getElementById('faqs');
                  if (section) {
                    section.scrollIntoView({ behavior: 'smooth' });
                  }
                }}>
                  PreguntasFrecuentes
                </a>
              </li>
              <li><a href="#guia-uso">Guía de Uso</a></li>
              <li>
                <a href="/contact">
                  Contáctenos
                </a>
              </li>
            </ul>
          </nav>
          <div className="footer-social">
            <div className="footer-social-title">Síguenos</div>
            <div className="footer-social-icons">
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="footer-social-icon">
                <img src="/images/vectorinstagran.png" alt="Instagram" style={{ borderRadius: '12px', background: '#40703E73' }} />
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="footer-social-icon">
                <img src="/images/vertoryouTube.png" alt="YouTube" />
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="footer-social-icon">
                <img src="/images/vectorFace.png" alt="Facebook" />
              </a>
            </div>
          </div>
        </div>

        {/* Footer Bottom Section */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p className="copyright">
              &copy; 2025 DataFono Crypto. Todos los derechos reservados.
            </p>
          </div>
        </div>
    </footer>
  );
};

export default Footer; 